import React from "react";
import { Box, Skeleton, useTheme } from "@mui/material";

const ProfileHeaderShimmer = () => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        textAlign: "center",
        mb: 4,
        p: 3,
        borderRadius: "4px",
        backgroundColor: "#001d3d",
        boxShadow: "0 2px 8px rgba(0,0,0,0.3)",
        border: "1px solid rgba(255,255,255,0.12)",
      }}
    >
      <Skeleton
        variant="text"
        width="60%"
        height={48}
        sx={{ mx: "auto", mb: 2 }}
      />
      <Skeleton
        variant="text"
        width="80%"
        height={24}
        sx={{ mx: "auto" }}
      />
    </Box>
  );
};

export default ProfileHeaderShimmer;